
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexIi8CpArsmn0fWUmY1dxhM0eaJ5ApdcMzFBCyJ5VHK9UMeta } from "C:/repositories/optilink-parent/web-portal-frontend/pages/index.vue?macro=true";
import { default as LoginyyiP01xq_45zEAg1gfCWRvsxrEasWuOgtvxwY0JdZnq_oMeta } from "C:/repositories/optilink-parent/web-portal-frontend/pages/Login.vue?macro=true";
import { default as _91id_93autFZFf9vtdImf5VHHur6XVyLEbRtk9E9sy7gXzKX8oMeta } from "C:/repositories/optilink-parent/web-portal-frontend/pages/dashboards/[id].vue?macro=true";
import { default as forgot_45passwordaZ_GK1IXPSEUOtYYxqKQ9SXd8vmxGa8IDArbGdU7DQwMeta } from "C:/repositories/optilink-parent/web-portal-frontend/pages/forgot-password.vue?macro=true";
import { default as indexlW_45rQ5zEe38oTClxE1_45abzrvA_lL5WFAnWrbrpFOLfsMeta } from "C:/repositories/optilink-parent/web-portal-frontend/pages/dashboards/index.vue?macro=true";
import { default as recover_45passwordgMXvCXeKOgD0AfPuK9qg_G1CuvIVS9KcWGnbB_45aWC44Meta } from "C:/repositories/optilink-parent/web-portal-frontend/pages/recover-password.vue?macro=true";
import { default as _91id_93y2uyHbfTfKHLk_pYGf3Qe91LNddiX9sxWYzYtRjiaJEMeta } from "C:/repositories/optilink-parent/web-portal-frontend/pages/shared/[tokenId]/[id].vue?macro=true";
import { default as indexts9NWqiFZddy5XbC2NAUaG3wsxlCBVEo1Xeuu_45PSplkMeta } from "C:/repositories/optilink-parent/web-portal-frontend/pages/[hexacode]/[department]/[subDepartment]/[page]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexIi8CpArsmn0fWUmY1dxhM0eaJ5ApdcMzFBCyJ5VHK9UMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/web-portal-frontend/pages/index.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: { ...(LoginyyiP01xq_45zEAg1gfCWRvsxrEasWuOgtvxwY0JdZnq_oMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/web-portal-frontend/pages/Login.vue")
  },
  {
    name: "dashboard",
    path: "/dashboards/:id()",
    meta: { ...(_91id_93autFZFf9vtdImf5VHHur6XVyLEbRtk9E9sy7gXzKX8oMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/web-portal-frontend/pages/dashboards/[id].vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("C:/repositories/optilink-parent/web-portal-frontend/pages/forgot-password.vue")
  },
  {
    name: "dashboards",
    path: "/dashboards",
    meta: { ...(indexlW_45rQ5zEe38oTClxE1_45abzrvA_lL5WFAnWrbrpFOLfsMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/web-portal-frontend/pages/dashboards/index.vue")
  },
  {
    name: "RecoverPassword",
    path: "/recover-password",
    meta: { ...(recover_45passwordgMXvCXeKOgD0AfPuK9qg_G1CuvIVS9KcWGnbB_45aWC44Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/web-portal-frontend/pages/recover-password.vue")
  },
  {
    name: "shared-dashboard",
    path: "/shared/:tokenId()/:id()",
    meta: _91id_93y2uyHbfTfKHLk_pYGf3Qe91LNddiX9sxWYzYtRjiaJEMeta || {},
    component: () => import("C:/repositories/optilink-parent/web-portal-frontend/pages/shared/[tokenId]/[id].vue")
  },
  {
    name: "department-page-view",
    path: "/:hexacode()/:department()/:subDepartment()/:page()",
    meta: { ...(indexts9NWqiFZddy5XbC2NAUaG3wsxlCBVEo1Xeuu_45PSplkMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("C:/repositories/optilink-parent/web-portal-frontend/pages/[hexacode]/[department]/[subDepartment]/[page]/index.vue")
  }
]